/* eslint-disable max-len */
import { RootState } from 'interfaces';
import { createSelector } from '@reduxjs/toolkit';
import { initialState } from './slice';

const selectDomain = (state: RootState) => state['feature/dashboard'] || initialState;

export const selectTopSessions = createSelector([selectDomain], (DashBoardState) => DashBoardState.topSessions);
export const selectCoachingHours = createSelector([selectDomain], (DashBoardState) => DashBoardState.coachingHours);
export const selectSessionsOverview = createSelector([selectDomain], (DashBoardState) => DashBoardState.sessionsOverview);
export const selectExpertEngagement = createSelector([selectDomain], (DashBoardState) => DashBoardState.expertEngagement);
export const selectExpertEarning = createSelector([selectDomain], (DashBoardState) => DashBoardState.expertEarning);
export const selectLoadingExpertEarning = createSelector([selectDomain], (DashBoardState) => DashBoardState.loadingExpertEarning);
